<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getParts"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >


      <template v-slot:headings>
        <div class="col-md-2">Date</div>
        <div class="col-md-1">Job</div>
        <div class="col-md-2">Creator</div>
        <div class="col-md-2">Received</div>
        <div class="col-md-5">Parts</div>
      </template>

      <template v-slot:rows="slotProps">      


         <div class="col-md-2 my-auto">
          <strong> #{{ slotProps.item.job_part_return_number }}</strong>
          
             <span
                    v-b-tooltip.hover
                    style="cursor: pointer"
                    title="Print"
                    @click="
                      vWindow.open(
                        `/pdf/reports/inventory/return/${slotProps.item.id}?cid=${slotProps.item.company_id}`
                      )
                    "
                    class="text-info table-action-icon"
                  >
                    <i class="lni lni-printer"></i>
                  </span>
          
          <br>
          {{
                  moment(new Date(slotProps.item.created_at)).format(
                    "DD MMM YY, HH:mm"
                  )
                }}<br>
                <span v-if="slotProps.item.fulfilled==1" class="badge badge-success">Returned</span>
        </div>

        <div class="col-md-1 my-auto">
          <span v-if="slotProps.item.job">
            {{ slotProps.item.job.job_number }}
          </span>
        </div>

        <div class="col-md-2 my-auto">
          <span v-if="slotProps.item.creator">
            {{ slotProps.item.creator.name }}
          </span>
        </div>

        <div class="col-md-2 my-auto">
          <span v-if="slotProps.item.receiver">
            {{ slotProps.item.receiver.name }}
          </span>
        </div>

         <div class="col-md-5 my-auto">
          <table class="table table-sm border">
            <tr class="bg-primary text-white">
              <td>Part</td>
              <td>Quantity</td>
            </tr>
            <tr v-for="l in slotProps.item.job_part_return_items" :key="l.id">
              <td>{{ l.part.description }}</td>
              <td>{{ l.quantity }}</td>

            </tr>
          </table>
        </div>

     
      </template>
    </data-table>

  </div>
</template>

<script>
import partRepo from "@/api/repos/partRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Date Created Desc", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: []
    };
  },
  mounted() {
    this.getParts({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
   
    async getParts(e) {
      this.isLoad = true;
      try {
        let { data } = await partRepo.returnsList(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.job_part_returns.data;
        this.totalRows = data.job_part_returns.total;
        this.page = data.job_part_returns.current_page;
        this.fromRow = data.job_part_returns.from;
        this.toRow = data.job_part_returns.to;
        this.lastPage = data.job_part_returns.last_page;

       
         
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

  
  },
};
</script>
